import { css } from '@emotion/core'
import { mq } from '../../cssInJs'

export default {
    pageTiles :css(mq({
          maxWidth : '960px',
          margin: 'auto'
    })),
    pageTile__tile : css(mq({
     margin: "10px",
    })),
    tile__content : css({
         '&:hover' : {
            textDecoration: 'none',
            '.pageTile__j5__content__details' : {
                 opacity:'1 !important'
            }
         } 
    }),
    tile__bg : css(mq({
        paddingTop: ['60%'],
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
    })),

    tile__details__title : css({
         fontSize: ['1.2rem'],
         fontWeight: '700'
    }),
    tile__details__desc : css(mq({
          fontSize : ['0.7rem']
    })),
    tile__btn_warpper : css({
        marginTop: '0.2rem'
    }),
    tile__redMore__btn : css(mq({
        padding: '0px 0.2rem',
        display:'inline-block',
        color: 'white',
        backgroundColor: '#a68c33',
        fontSize:'0.9rem'
    })),
    slider__warpper:css(mq({
         marginLeft: ['-7px'],
         marginRight: ['-7px'],
         '& .slick-prev' : css(mq({
               left: ['5px','-22px'],
               top: ['20%','50%']
         })),
         '& .slick-next' : css(mq({
              right:['5px','-22px'],
              top: ['20%','50%']
          })),
          '& .slick-prev, & .slick-next' : css({
               '&:before' :css({
                    color: 'grey'
               })
          })
    }))
}